import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import useNavigator from "@saleor/hooks/useNavigator";
import * as React from "react";

import { remittanceRunnerToRemitPath } from "../../url";

const useStyles = makeStyles(
  theme => ({
    btnRemit: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main,
      marginTop: "10px"
    },
    lblRemit: {
      color: "#ffffff !important"
    }
  }),
  { name: "RemittanceRunnerRemitButton" }
);

const RemittanceRunnerRemitButton: React.FC = props => {
  const classes = useStyles(props);
  const navigate = useNavigator();

  const handleNavigate = (path: string, external: boolean): void => {
    if (external) {
      window.open(path, "_blank").focus();
      return;
    }

    navigate(path);
  };

  return (
    <div>
      <Button
        color="primary"
        variant="contained"
        className={classes.btnRemit}
        onClick={() => handleNavigate(remittanceRunnerToRemitPath, false)}
      >
        <span className={classes.lblRemit}>Remit</span>
      </Button>
    </div>
  );
};

export default RemittanceRunnerRemitButton;
